import React from "react";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../../stores/calculateStore";
import { FormControlLabel, FormHelperText, Radio, RadioGroup } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";

import Notification from "../../../sharedComponents/notification/notification";
import { PolicyDurationId } from "../../../../helpers/additionalQuestions/policyDuration";
import {
  PaymentModeId,
  PaymentModeVariants,
  PaymentModeVariantsModel
} from "../../../../helpers/additionalQuestions/paymentMode";

interface PaymentModeProps {
  calculateStore?: CalculateStore;
}

export function PaymentMode(props: PaymentModeProps) {

  const calculateStore = props.calculateStore!;
  const paymentMode = calculateStore.additionalQuestions.paymentMode;

  const onChange = (event: any) => {
    props.calculateStore!.setPaymentMode(event.target.value);
    validate();
  };

  return (
    <div className="additional-questions-section payment-mode">
      <div className="question-answer-container">
        <div className="question">Na ile rat rozłożona składka?</div>
        <FormControl error={!!paymentMode.errorMessage}>
          <RadioGroup
            className="question-radio"
            onChange={onChange}
            value={paymentMode.value}>
            {PaymentModeVariants
              .filter(paymentModeModel => filterByPaymentMode(paymentModeModel))
              .map((variant) => renderOption(variant.installments, variant.label))}
          </RadioGroup>
          {paymentMode.errorMessage && (
            <FormHelperText>
              <Notification type="error" message={paymentMode.errorMessage} />
            </FormHelperText>
          )}
        </FormControl>
      </div>
    </div>
  );

  function renderOption(value: PaymentModeId | null, label: string | null) {
    return (
      <FormControlLabel key={"option_" + value}
        value={value}
        control={<Radio className={(!!paymentMode.errorMessage) ? "error-radio" : ""} />}
        label={
          <div className={"option option_" + value}>
            <div className="option-label">
              {label}
            </div>
          </div>} />
    );
  }

  function filterByPaymentMode(paymentModeVariant: PaymentModeVariantsModel) {
    const policyDuration = props.calculateStore!.additionalQuestions.policyDuration.value;

    if (policyDuration === PolicyDurationId.MONTHS_12 || policyDuration === null) {
      return !(paymentModeVariant.installments === PaymentModeId.yearly || paymentModeVariant.installments === PaymentModeId.quarterly);
    }
    return !(paymentModeVariant.installments === PaymentModeId.halfYearly);
  }

  function validate() {
    paymentMode.validatePaymentMode();
  }
}

export default inject("calculateStore")(observer(PaymentMode));
